import { render, staticRenderFns } from "./CriteriaStructureManagement.vue?vue&type=template&id=0bc509e8"
import script from "./CriteriaStructureManagement.vue?vue&type=script&lang=js"
export * from "./CriteriaStructureManagement.vue?vue&type=script&lang=js"
import style0 from "./CriteriaStructureManagement.vue?vue&type=style&index=0&id=0bc509e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports